import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnRange, componentMap as formComponentMap } from '@cainiaofe/cn-ui';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Range',
    component: CnRange,
    formComponent: formComponentMap.CnRange,
};
